var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('span',{staticClass:"pull-left"},[_vm._v(_vm._s(_vm.optionItem.name))])]),_c('core-goods-field',{staticClass:"clearfix",attrs:{"optionItem":_vm.optionItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }